module.exports = __webpack_public_path__ + "img/mesa_d112.c57f22f2.png";